<template>
  <span class="sp-language-summary">
    <span v-if="visibleCodes.length">{{ visibleCodes.join(', ') }}</span>
    <span v-else>No lead languages</span>
    <span v-if="remainingCount" class="sp-language-summary__more">+{{ remainingCount }}</span>
  </span>
</template>

<script>
export default {
  name: 'ShiftPlannerLanguageSummary',
  props: {
    languages: {
      type: Array,
      default: () => []
    },
    limit: {
      type: Number,
      default: 2
    }
  },
  computed: {
    codes() {
      return this.languages.map(item => item.code).filter(Boolean)
    },
    visibleCodes() {
      return this.codes.slice(0, this.limit)
    },
    remainingCount() {
      return Math.max(0, this.codes.length - this.visibleCodes.length)
    }
  }
}
</script>

<style lang="scss" scoped>
.sp-language-summary {
  align-items: center;
  display: inline-flex;
  flex-wrap: wrap;
  gap: 5px;
}

.sp-language-summary__more {
  min-height: 24px;
  align-items: center;
  justify-content: center;
  background: $ui-blue-soft;
  border: 1px solid $ui-line-strong;
  border-radius: 8px;
  color: $ui-ink;
  display: inline-flex;
  font-family: $ui-font-heading;
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  padding: 2px 7px;
}
</style>
